import React from "react"
import PropTypes from "prop-types"
import { StyledFieldset, Legend, VideoHintList, VideoHintP, VideoHintHeading } from "./styles"
import Card from "../../card"
import Grid from "../../grid"
import Markdown from "../../markdown"
import Content from "../../content"

const Fieldset = ({ children, legendText, content, showVideoHint, videoUrl, simpleForm, last }) => {
  const cardVariant = simpleForm ? "white" : "primary"
  const legendVariant = simpleForm ? "primary" : "body"
  const legendSize = simpleForm ? "simpleForm" : "large"
  const markdownVariant = simpleForm ? "simpleForm" : "default"

  return (
    <StyledFieldset simpleForm={simpleForm} last={last}>
      <Card variant={cardVariant} paddingless={!!simpleForm} simpleForm>
        <Legend size={legendSize} variant={legendVariant}>
          {legendText}
        </Legend>
        <Grid gap={simpleForm ? "1.5rem" : "1rem"}>
          {!videoUrl && (
            <Markdown
              componentStyles={{
                h1: { variant: markdownVariant },
                h2: { variant: markdownVariant },
                h3: { variant: markdownVariant },
                p: { variant: markdownVariant },
                li: { variant: markdownVariant },
                a: { variant: markdownVariant }
              }}
            >
              {content}
            </Markdown>
          )}
          {videoUrl && <Content content={content} videoUrl={videoUrl} inlineOnMobile={true}></Content>}
          {children}
          {showVideoHint && (
            <>
              <VideoHintHeading simpleForm={simpleForm}>Tips for Video URLs</VideoHintHeading>
              <VideoHintP simpleForm={simpleForm}>
                From YouTube or Vimeo, find your video and click <b>Share</b> then <b>Embed</b> and copy just the URL
                and paste below.
              </VideoHintP>
              <VideoHintP simpleForm={simpleForm}>It will look like this with your video ID at the end</VideoHintP>

              <VideoHintList simpleForm={simpleForm}>
                <li>https://www.youtube.com/embed/videoID OR</li>
                <li>https://player.vimeo.com/video/videoID</li>
              </VideoHintList>
            </>
          )}
        </Grid>
      </Card>
    </StyledFieldset>
  )
}

Fieldset.propTypes = {
  children: PropTypes.node,
  legend: PropTypes.string,
  content: PropTypes.string,
  videoUrl: PropTypes.string
}

Fieldset.defaultProps = {
  content: "",
  videoUrl: ""
}

export default Fieldset
